export default "__VITE_ASSET__YyuIrIcz__"